import { QRCode } from 'react-qrcode-logo';
import { toast } from 'sonner';
import { MdOutlineFileCopy } from 'react-icons/md';
import { IoIosArrowBack } from 'react-icons/io';
import { Button } from '@/components/ui/button';
import usePaymentProvider from '@/hooks/deposit/usePaymentProvider';
import { useSession } from '@/contexts/LitSessionProvider';
export default function WalletQr() {
  const {
    PKP
  } = useSession();
  const {
    resetProvider,
    selectedPaymentMethod,
    setSelectedPaymentMethod
  } = usePaymentProvider();
  const qrCodeValue = selectedPaymentMethod === 'evm' ? PKP?.additionalEthAddress : PKP?.solanaAddress;
  return <div className='ta-c h-full' data-sentry-component="WalletQr" data-sentry-source-file="WalletQr.tsx">
      <div onClick={() => {
      setSelectedPaymentMethod(null);
      resetProvider();
    }} className='absolute cursor-pointer left-6 top-6 text-[14px] flex items-center bg-genius-blue rounded-full h-[31px] w-[74px]'>
        <IoIosArrowBack className={`ml-2 mr-2 w-[16px] text-genius-cream`} width={20} height={18} data-sentry-element="IoIosArrowBack" data-sentry-source-file="WalletQr.tsx" />{' '}
        <p>Back</p>
      </div>

      <div className='rounded-xl border-genius-blue border-[1px] flex items-center p-[3px] text-[12px] w-fit mt-6'>
        <div onClick={() => {
        setSelectedPaymentMethod('evm');
      }} className={`text-[14px] px-2 py-1 rounded-lg ${selectedPaymentMethod === 'evm' && 'bg-genius-blue'}`}>
          EVM
        </div>
        <div onClick={() => {
        setSelectedPaymentMethod('solana');
      }} className={`text-[14px] px-2 py-1 rounded-lg ${selectedPaymentMethod === 'solana' && 'bg-genius-blue'}`}>
          Solana
        </div>
      </div>
      <div className='my-6 '>
        <QRCode bgColor='#241747' fgColor='#ffffff' size={145} logoImage='/static/images/logo-3d.png' logoHeight={10} qrStyle='squares' logoWidth={10} logoPadding={qrCodeValue.startsWith('0x') ? 5 : 8} eyeRadius={0} style={{
        borderRadius: 0
      }} removeQrCodeBehindLogo={true} value={qrCodeValue} data-sentry-element="QRCode" data-sentry-source-file="WalletQr.tsx" />
      </div>
      <div>
        <p className='text-genius-cream/50 text-[10px] px-6'>
          {qrCodeValue.startsWith('0x') ? <>
              <p>
                Genius supports Avalanche, Base, Polygon, Optimism, Arbitrum, BNB chain, and
                Ethereum Mainnet.
              </p>
              <p className='mt-2'>
                Do NOT send funds on any other networks. Genius is not responsible for lost funds.
                Genius recommends sending ETH of USDC.
              </p>
              <br></br>Note: If you’re depositing on Ethereum Mainnet, the minimum order must be
              over $75 due to gas fees.
            </> : <div className='w-[240px] leading-3'>
              <p>
                Genius strongly recommends sending only SOL or USDC on Solana. Genius is not
                responsible for lost funds if you send funds to the wrong address.
              </p>
            </div>}
        </p>
      </div>
      <div className='border-genius-blue border-[1px] py-1 px-2 w-fit mt-6 rounded-md'>
        <p className='text-[10px]'>
          {selectedPaymentMethod === 'evm' ? PKP?.additionalEthAddress : PKP?.solanaAddress}
        </p>
      </div>
      <div className='w-full px-4'>
        <Button onClick={async () => {
        await navigator.clipboard.writeText(qrCodeValue);
        toast(`Copied ${qrCodeValue} clipboard`, {
          position: 'bottom-right',
          dismissible: true,
          duration: 1000
        });
      }} className='rounded-full w-full mt-6 bg-genius-pink text-[14px] hover:bg-genius-pink text-genius-blue h-[56px]' data-sentry-element="Button" data-sentry-source-file="WalletQr.tsx">
          <MdOutlineFileCopy className='w-[20px] h-[20px] mr-2' data-sentry-element="MdOutlineFileCopy" data-sentry-source-file="WalletQr.tsx" /> Copy Address
        </Button>
      </div>
    </div>;
}